import styles from '../Markers.module.scss';

export const getClusterStyle = (clusterCount?: string) => {
	switch (clusterCount?.length) {
		case 1:
			return styles.xs;
		case 2:
			return styles.sm;
		case 3:
			return styles.md;
		case 4:
			return styles.lg;
		case 5:
			return styles.xl;
		default:
			return styles.xl;
	}
};
